module.exports = __webpack_public_path__ + "static/media/skittles.1ac7b38d.jpg";